import React, { useState, useEffect } from "react";
import { Container, Card } from "react-bootstrap";
import logonew from "../../assets/img/logo.png";
import axios from "axios";

export default function Appdetails() {
  useEffect(() => {
    getbasicinfo();
  }, []);
  const [logoDymanic, setlogo] = useState();
  const [id, setid] = useState();
  const [logourl, setlogourl] = useState();
  const getbasicinfo = async () => {
    const hostURL = window.location.origin;
    const urlWithoutProtocol = hostURL.replace(/^https?:\/\//, "");
    const apiUrl = `${process.env.REACT_APP_API_URL_NODE}get-basic-info`;
    const requestData = {
      app_id: process.env.REACT_APP_API_ID,
      hostname: urlWithoutProtocol,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      // console.warn(data.message.url);

      if (data.status_code) {
        setlogo(data.message.logo);
        setlogourl(data.message.url + data.message.logo);
        setid(data.message.id);

        localStorage.setItem("a_id", data.message.id);
        localStorage.setItem("domain", urlWithoutProtocol);
      } else {
        localStorage.removeItem("a_id");
        localStorage.removeItem("domain");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  return (
    <>
      <section id="appdetials" className="margin-bottom-88">
        <Container fluid>
          <div className="detailsapplication">
            {logoDymanic ? (
              <div className="bg-img">
                <img src={logourl} />
              </div>
            ) : (
              <div className="bg-img">
                <img src={logonew} />
              </div>
            )}
          </div>
          <Card>
            <div className="detailscard">
              <h6>
                <strong>TM Application:369852114751</strong>
              </h6>
            </div>
          </Card>
          <Card>
            <div className="detailscard">
              <h6>
                <strong>ARN Number:369852114751</strong>
              </h6>
            </div>
          </Card>
          <Card>
            <div className="detailscard">
              <h6>
                <strong>Provisional ID:369852114751</strong>
              </h6>
            </div>
          </Card>
        </Container>
      </section>
    </>
  );
}
